import React from 'react';
import { Link } from 'react-router-dom';
var pic = require('../../assets/images/buildings/about/pic7.jpg');
var fort = require('../../assets/images/buildings/about/alila-bishangarh.jpg');
//var aboutPic1 = require('../../assets/images/buildings/about/alila-bishangarh.jpg');
const AboutWelcomeBlock = (props) => {	  	
    return(
	<>
	{/* <!-- ABOUT COMPANY SECTION START --> */}
	<div className="section-full p-t80 p-b50">
		<div className="container">
			<div className="row">
				<div className="col-lg-6 col-md-8 m-b30">
					<div className="about-com-pic">
						<img src={pic} alt="" className="img-responsive" />
					</div>
				</div>
				<div className="col-lg-6 col-md-8 m-b30">
					<div className="about-com-pic">
						<img src={fort} alt="" className="img-responsive" />
					</div>
				</div>
				<div className="col-lg-12 col-md-12 m-b30">
					<div className="section-head text-left">
						<h3 className="text-uppercase">About School </h3>
						<div className="wt-separator-outer">
							<div className="wt-separator style-icon">
								<i className="fa fa-leaf text-black"></i>
								<span className="separator-left site-bg-primary"></span>
								<span className="separator-right site-bg-primary"></span>
							</div>                            
						</div>
						<p>We balance academics with co-curricular and extracurricular activities, enriching the RBSE curriculum with diverse techniques. Students engage in debates, arts, sports, and hobby clubs, learning teamwork and management. Vocational workshops provide career skills, while our career-orientation program guides each student’s talents. This holistic approach fosters comprehensive growth.</p>
						
						
					</div>
					<div className="about-types row">
						<div className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30">
							<div className="wt-icon-box-wraper left">
								<div className="icon-md site-text-primary">
									<Link to="# " className="icon-cell p-t5 center-block"><i className="flaticon-mirror"></i></Link>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b10">Strategies</h5>
									<p>Our Young Pre classroom is for ages This age group is working on developing their fine and gross motor skills.</p>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30 ">
							<div className="wt-icon-box-wraper left">
								<div className="icon-md site-text-primary">
									<Link to="# " className="icon-cell p-t5 center-block"><i className="flaticon-mirror"></i></Link>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b10">Motivation</h5>
									<p>Techniques such as setting achievable goals & providing feedback can boost motivation & encourage persistence in students.</p>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30 ">
							<div className="wt-icon-box-wraper left">
								<div className="icon-md site-text-primary">
									<Link to="# " className="icon-cell p-t5 center-block"><i className="flaticon-mirror"></i></Link>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b10 ">Cute Environment</h5>
									<p>Prissy expectant involuntarily limpet until cobra less dear so overabundant contagion.</p>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30 ">
							<div className="wt-icon-box-wraper left">
								<div className="icon-md site-text-primary">
									<Link to="# " className="icon-cell p-t5 center-block"><i className="flaticon-mirror" aria-hidden="true"></i></Link>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b10">Children Safety</h5>
									<p>Prissy expectant involuntarily limpet until cobra less dear so overabundant contagion</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>   
	{/* <!-- ABOUT COMPANY SECTION END --> */} 
    </>
    )
}
export default AboutWelcomeBlock;